<div class="artifact" >
    <button (click)="playArtifactAudio(audioPlayer)" *ngIf="artifact">      
        <div class="audio-icon">
            <i class="fa fa-volume-up" aria-hidden="true"></i>  
        </div>
    </button>
    <audio #audioPlayer>
        <!-- <source [src]="getArtifactBinary(artifact)" type="audio/mp3"> -->
    </audio>
</div>
